import React from 'react';

const WaitingScreen = () => (
	<div className="waiting-wrap">
		<div className="badge">✨ Intervue Poll</div>
		<div className="spinner-lg" />
		<h2 className="wait-title">Wait for the teacher to ask questions..</h2>
	</div>
);

export default WaitingScreen;